import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router-dom';
import {requestSurvey, requestEditSurvey} from '../../actions/action_survey';
import {organizationRequest} from '../../actions/action_organization';
import Loader from '../Loader';
import Title from '../Title';
import SurveyEditForm from './SurveyEditForm';
import Alert from '../Alert';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';
import CawiButton from './CawiButton';
import SubTitle from '../SubTitle';

class SurveyEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: null,
        };
        this.saveCallback = this.saveCallback.bind(this);
    }

    componentDidMount() {
        this.props.organizationRequest();
        // this.props.requestSurvey(this.props.match.params.id);
        this.setState({item: null}, () => this.props.requestSurvey(this.props.match.params.id));
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            // needed to comment this out and moving it componentDidMount in  to avoid loosing the state of the form when saving a survey and keep the
            // form updated when navigating to another survey
            // this.setState({item: null}, () => this.props.requestSurvey(this.props.match.params.id));
        }
    }

    saveCallback(data) {
        // still wondering why state doesn't get updated entirely (updatedAt)
        // we are trying to merge updatedAt to avoid editing collisions
        const payload = Object.assign({}, data, {updatedAt: this.props.item.updatedAt});
        this.setState({item: payload}, () =>
            this.props.requestEditSurvey(this.props.match.params.id, payload));
    }

    renderContent() {
        const {loading, error, organization} = this.props;

        let item = this.state.item || this.props.item;
        if (item && item.id !== this.props.match.params.id) {
            item = null;
        }

        const actions = (
            <div>
                {item && (
                    <>
                        {item.consoleButtons.length > 0 && (
                            item.consoleButtons.map((b, i) => (
                                <a className="btn btn-outline-secondary mr-2" target="_blank" rel="noopener noreferrer" href={b.url} key={i}>{b.label}</a>
                            ))
                        )}
                        <Link to={`/dashboard/${item.id}`} className="btn btn-outline-secondary mr-2">
                            <Icon icon="istogram" /> <FormattedMessage {...messages.surveys.button.dashboard} />
                        </Link>
                        <CawiButton id={item.id} disabled={item.editor.pages.length === 0} />
                    </>)}
            </div>
        );

        return (
            <div className="row">
                <div className="col-md-2 col-12">
                    <Link className="navbar-brand" to="/surveys">
                        <button type="button" className="btn btn-outline-primary btn-sm">
                            <Icon icon="arrow_left" /> <FormattedMessage {...messages.buttons.back} />
                        </button>
                    </Link>
                </div>
                <div className="col-md-8 col-12">
                    <Title actions={actions}><FormattedMessage {...messages.surveys.title.edit} /></Title>
                    <SubTitle>{item && item.name}</SubTitle>
                    {loading && <Loader overlay={!!(this.state.item || item)} />}
                    {item && organization && <SurveyEditForm item={item} error={error} organization={organization}
                        saveCallback={this.saveCallback} />}
                </div>
            </div>
        );
    }

    render() {
        const {error} = this.props;
        return (error && !this.state.item && <Alert error={error} /> || this.renderContent());
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.survey.item,
        loading: state.survey.loading || state.organization.loading,
        error: state.survey.error,
        organization: state.organization.current,
    };
};

export default connect(mapStateToProps, {organizationRequest, requestSurvey, requestEditSurvey})(SurveyEdit);
